import { SET_SDE_ANALYSIS_REPORT, SET_HDE_ANALYSIS_REPORT } from "./mutations";

const initialState = {
  currentCompanySDEAnalysis: null,
  currentCompanyHDEAnalysis: null,
};

const qualityOfEarningsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SDE_ANALYSIS_REPORT:
      return { ...state, currentCompanySDEAnalysis: payload };

    case SET_HDE_ANALYSIS_REPORT:
      return { ...state, currentCompanyHDEAnalysis: payload };
    
    default:
      return state;
  }
};

export default qualityOfEarningsReducer;
